export function getLanguages() {
    return [
        { key: 'English',       value: 'english',       id: 1, },
        { key: 'Spanish',       value: 'spanish',       id: 2, },
        { key: 'French',        value: 'french',        id: 3, },
        { key: 'German',        value: 'german',        id: 4, },
        { key: 'Portuguese',    value: 'portuguese',    id: 5, },
    ];
}

export function getSupportedLanguages() {
    return [
        { key: 'English',       value: 'english',       id: 1, },
        { key: 'Spanish',       value: 'spanish',       id: 2, },
        { key: 'French',        value: 'french',        id: 3, },
    ];
}